import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import {
  Form,
  Button as BButton,
  Button as BsButton,
  InputGroup,
  Button,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { MultiSelect } from "react-multi-select-component";
import { CallGETAPI, CallPOSTAPI } from "../../../common/services";
import { userContactList } from "../../../common/helper/BasicFn";
import { sortArrAscending } from "../../../common/helper/constants";

const EditAssignUserRoleModal = ({
  show,
  setShow,
  roleData,
  rowData,
  allSites,
  fetchCreateTblData,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const [contactList, setContactList] = useState([]);
  const [allSortedRoles, setAllSortedRoles] = useState([]);
  const [allContactSites, setAllContactSites] = useState([]);
  const [currentSites, setCurrentSites] = useState([]);
  const [formData, setFormData] = useState({
    account_id: "",
    contact_id: "",
    role_id: [],
    site_id: [],
    role_type: "",
  });

  const [isInvalid, setIsInvalid] = useState({
    role_id: false,
    site_id: false,
  });

  const handleChange = (e, key) => {
    const { value } = e.target;

    if (key === "account_id") {
      setSelectedAccountId(value);
    }
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const fetchContactData = async (selectedAccountId) => {
    const res = await userContactList(selectedAccountId);

    setContactList(res);
  };

  useEffect(() => {
    if (selectedAccountId !== null) {
      fetchContactData(selectedAccountId);
    }
  }, [selectedAccountId]);

  const handleSiteChange = (e) => {
    setFormData({
      ...formData,
      site_id: e,
    });
  };

  function getCommonItems(array1, array2, key) {
    return array1.filter((item1) =>
      array2.length > 0
        ? array2.some(
            (item2) =>
              item1["account_site_info_id"] !== item2["account_site_info_id"]
          )
        : item1
    );
  }

  const getAllSitesByContactId = async (id, account_id) => {
    try {
      const account_site_reponse = await CallGETAPI(
        `site/account-site-list/${account_id}`
      );
      if (account_site_reponse.data.status) {
        const account_site_list = account_site_reponse.data.data.site_details;

        const response = await CallGETAPI(
          `permission/account-site-list-by-contact/${id}?search=&page=${1}&pageSize=${50}`
        );
        if (response.data.status) {
          const current_sites =
            response.data.data !== "" ? response.data.data.site_details : [];

          const commonItems = getCommonItems(
            account_site_list,
            current_sites,
            "id"
          );

          let all_data = commonItems
            ? commonItems.map((item) => {
                return {
                  label: item.account_site_name,
                  value: item.account_site_info_id,
                };
              })
            : [];

          const siteIdArray = rowData.assigned_site.split(",").map(Number);

          const siteIdObj = all_data.filter((item) =>
            siteIdArray.includes(item.value)
          );

          setCurrentSites(siteIdObj);

          setAllContactSites(all_data);
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (rowData) {
      handleRoles();
      getAllSitesByContactId(rowData.contact_id, rowData.account_id);
    }
  }, [rowData]);

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    // console.log({ formData });
    // console.log({ currentSites });
    let is_false = 0;
    let obj = {
      role_id: false,
      site_id: false,
    };

    if (formData.role_id.length === 0) {
      obj.role_id = true;
      is_false = 1;
    }

    if (formData.role_type === "site_level" && currentSites.length === 0) {
      obj.site_id = true;
      is_false = 1;
    }

    if (is_false) {
      setIsInvalid(obj);
      return "";
    }

    setLoading(true);
    let rolesArr = formData.role_id;
    let siteIdArr = formData.site_id;
    let finalRolesArr = rolesArr.map((role) => role.value);
    let finalsitesArr = siteIdArr.map((role) => role.value);
    let body = {
      ...formData,
      // site_id:
      //   currentSites.length > 0
      //     ? currentSites.map((item) => item.value).toString()
      //     : "",
      site_id: finalsitesArr + "",
      role_id: finalRolesArr + "",
    };

    const res = await CallPOSTAPI(
      "permission/update-permission-user/" + rowData.contact_id,
      body
    );
    fetchCreateTblData();
    if (res?.status) {
      setLoading(false);
      toast.success("Role Updated Successfully");
      setShow(false);
      setCurrentSites([]);
    }
  };

  const handleRoleChange = (e) => {
    setFormData({
      ...formData,
      role_id: e,
    });
    setIsInvalid({ ...isInvalid, role_id: false });
  };

  const renderSelectedTitleNames = () => {
    return [formData.role_id.map((item) => item.label).join(", ")];
  };

  const renderSelectTitle = () => {
    return (
      <div>
        {formData.role_id.length >= 3
          ? `${formData.role_id.length} Selected`
          : renderSelectedTitleNames()}
      </div>
    );
  };

  const handleRoles = () => {
    if (roleData) {
      const nrda = roleData
        .filter((item) => item.role_type === rowData.roles[0].role_type)
        .map((obj) => ({
          label: obj.role_name,
          value: obj.role_id,
        }));

      let sortedArr = sortArrAscending(nrda, "label");
      const roleIdArray = rowData.assigned_role.split(",").map(Number);

      const roleIdObj = sortedArr.filter((item) =>
        roleIdArray.includes(item.value)
      );

      setFormData({
        ...formData,
        role_id: roleIdObj,
        account_id: rowData?.account_name,
        contact_id: rowData?.contactName,
        role_type: rowData?.roles[0]?.role_type,
      });
      setAllSortedRoles(sortedArr);
    }
  };

  useEffect(() => {
    if (rowData) {
      handleRoles();
    }
  }, [rowData]);

  const renderSelectedSiteNames = () => {
    return [currentSites.map((item) => item.label).join(", ")];
  };

  const renderSiteTitle = () => {
    return (
      <div>
        {currentSites.length >= 6
          ? `${currentSites.length} Selected`
          : renderSelectedSiteNames()}
      </div>
    );
  };

  return (
    <>
      <Modal show={show} onHide={() => setShow(false)} size="lg" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Edit Assign Role to User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={handleModalSubmit}
            noValidate
            // validated={validated}
            //   id="create-new-equipment-form"
          >
            <div
              className="my-4"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "5%",
                justifyContent: "space-between",
                margin: "auto",
              }}
            >
              <Form.Group style={{ width: "180px" }}>
                <Form.Label>Select Role*</Form.Label>

                <MultiSelect
                  hasSelectAll={false}
                  valueRenderer={renderSelectTitle}
                  options={allSortedRoles}
                  value={formData.role_id}
                  onChange={(e) => handleRoleChange(e)}
                  labelledBy="Select"
                />

                {isInvalid.role_id && (
                  <Form.Control.Feedback type="" className="text-danger mt-1">
                    Please Select Role.
                  </Form.Control.Feedback>
                )}
              </Form.Group>

              <Form.Group>
                <Form.Label>Select Account</Form.Label>
                <Form.Control
                  type="text"
                  name="account_id"
                  value={formData.account_id}
                  onChange={(e) => handleChange(e, "account_id")}
                  // required
                  disabled={true}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Select Contact</Form.Label>
                <Form.Control
                  type="text"
                  name="contact_id"
                  value={formData.contact_id}
                  onChange={(e) => handleChange(e, "contact_id")}
                  // required
                  disabled={true}
                />
              </Form.Group>

              {formData.role_type === "site_level" && (
                <Form.Group style={{ width: "180px" }}>
                  <Form.Label>Select Site</Form.Label>
                  <MultiSelect
                    valueRenderer={renderSiteTitle}
                    options={allContactSites ? allContactSites : []}
                    value={currentSites}
                    onChange={(e) => {
                      setCurrentSites(e);
                      handleSiteChange(e);
                      setIsInvalid({ ...isInvalid, site_id: false });
                    }}
                    labelledBy="Select"
                    hasSelectAll={false}
                  />

                  {isInvalid.site_id && (
                    <Form.Control.Feedback type="" className="text-danger mt-1">
                      Please Select Sites.
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              )}
            </div>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <div className=" d-flex justify-content-end">
            <button
              className="btn btn-danger mt-0"
              type="button"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
            &nbsp;
            <Button
              variant="success"
              // type="submit"
              onClick={(e) => handleModalSubmit(e)}
              className="mt-0"
              disabled={loading}
            >
              {loading ? "Loading..." : "Submit"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditAssignUserRoleModal;
